var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.3398 54.3647L40.937 40.9619L27.5342 54.3647",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9375 40.9619V71.1182",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0495 62.3728C72.3175 60.5911 74.8992 57.7719 76.3871 54.36C77.8749 50.9481 78.1842 47.1379 77.2661 43.5307C76.348 39.9236 74.2548 36.7249 71.3168 34.4395C68.3788 32.1541 64.7635 30.9122 61.0413 30.9097H56.8194C55.8052 26.9868 53.9149 23.3449 51.2906 20.2578C48.6663 17.1707 45.3763 14.7186 41.6679 13.086C37.9595 11.4534 33.9293 10.6827 29.8802 10.8319C25.8311 10.9811 21.8685 12.0463 18.2903 13.9473C14.7121 15.8484 11.6115 18.5359 9.22145 21.8078C6.83143 25.0797 5.21424 28.8508 4.49146 32.8377C3.76868 36.8245 3.95911 40.9234 5.04845 44.826C6.13779 48.7287 8.09769 52.3336 10.7808 55.3698",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3398 54.3647L40.937 40.9619L27.5342 54.3647",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/UploadIcon.e94204de9fc774f590d72862cce8fd3a.svg";
export { ForwardRef as ReactComponent };